import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './WorkingEnvironment.css';

const WorkingEnvironment = () => {

  return (
    <div className="working-environment-container">
      <Navbar />
      <div className="working-environment-content">
        <h1>Working Environment</h1>
        <div className="working-environment-sections">
          <section className="environment-section">
            <div className="section-content">
              <h2>Our Workplace Culture</h2>
              <p>At Biyanis Education Group, we foster a collaborative and innovative environment where every team member's contribution is valued. Our workplace culture is built on the pillars of:</p>
              <ul>
                <li>Professional Growth and Development</li>
                <li>Work-Life Balance</li>
                <li>Inclusive and Diverse Environment</li>
                <li>Continuous Learning</li>
              </ul>
            </div>
          </section>

          <section className="environment-section">
            <div className="section-content">
              <h2>Facilities and Amenities</h2>
              <p>We provide our employees with state-of-the-art facilities to ensure a comfortable and productive work environment:</p>
              <ul>
                <li>Modern Office Spaces</li>
                <li>High-Speed Internet</li>
                <li>Break Rooms and Cafeteria</li>
                <li>Health and Wellness Programs</li>
              </ul>
            </div>
          </section>

          <section className="environment-section">
            <div className="section-content">
              <h2>Career Development</h2>
              <p>We believe in nurturing talent and providing opportunities for professional growth. Our career development programs include:</p>
              <ul>
                <li>Regular Training Sessions</li>
                <li>Mentorship Programs</li>
                <li>Leadership Development</li>
                <li>Skill Enhancement Workshops</li>
              </ul>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default WorkingEnvironment; 